import { IRoomUsageAlertChannelSettings, TChannelType } from "./types";
import { AlarmChannel, updateMeetingRoomUsageConfirmAlarmChannel } from "apis/alarm-settings";

//* 회의실 이용 확인 알림 채널 설정 서비스
export const roomUsageAlertChannelSettingServices: IRoomUsageAlertChannelSettings = {
  onChangeChannel: async (
    channel: TChannelType,
    showToast: (message: string, type: "success" | "error") => void,
    onChangeChannel: (channel: TChannelType) => void
  ) => {
    const res = await updateMeetingRoomUsageConfirmAlarmChannel(channel as AlarmChannel);
    if (res.success) {
      showToast("회의실 이용 확인 알림 채널이 변경되었습니다.", "success");
      onChangeChannel(channel);
    } else {
      showToast("설정 변경에 실패했습니다. 다시 시도해 주세요.", "error");
    }
  },
};
